module.exports = __webpack_public_path__ + "img/orbea.d339b9dc.jpg";